function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "tw-col-span-full md:tw-col-span-2 tw-grid tw-gap-x-15px"
};
var _hoisted_2 = {
  "class": "tw-font-semibold tw-col-span-2"
};
var _hoisted_3 = {
  "class": "tw-col-span-full md:tw-col-span-2 tw-grid tw-gap-x-15px"
};
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  "data-cy": "auction-date-from",
  "class": "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
var _hoisted_7 = {
  "data-cy": "auction-date-to",
  "class": "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
var _hoisted_8 = {
  "data-cy": "publication-date-from",
  "class": "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
var _hoisted_9 = {
  "data-cy": "publication-date-to",
  "class": "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
import { ref, computed, onMounted, watch } from "vue";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
import { formatterNumberObj } from "@utils/NumberUtils";
import { formatDateToddMMYYYY, subtractDaysFromDate } from "@utils/DateUtils";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { getAuctionSaleModeList } from "@services/AuctionAPI";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionFilters',
  props: {
    shrinkTo4Columns: {
      type: Boolean,
      "default": false
    },
    listingTypologyActive: {
      type: Boolean,
      "default": false
    },
    customContainerClass: {
      "default": ""
    },
    searchBean: {
      "default": {}
    },
    clearFilters: {
      type: Boolean,
      "default": false
    },
    forceCloseAllDropDown: {
      type: Boolean,
      "default": false
    },
    insideModal: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["changed", "cleared", "forceClosed", "counterResb"],
  setup: function setup(__props, _ref) {
    var _this = this;
    var __emit = _ref.emit;
    var props = __props;
    var optionSellingType = ref({
      id: 0
    });
    var optionCourtType = ref({
      id: 0
    });
    var auctionFiltersSearchBean = ref(Object.assign(Object.assign({}, props.searchBean), {
      sale: false,
      rent: false,
      auctionType: 1,
      contractType: 3
    }));
    var forceCloseMultiTypologyLocal = ref(false);
    var forceCloseAllDropdown = ref(false);
    /*const court = ref([]);*/
    var sellingType = ref([]);
    var emit = __emit;
    var formatter = computed(function () {
      return formatterNumberObj;
    });
    var minDate = computed(function () {
      return subtractDaysFromDate(undefined, 15);
    });
    var _useCommonVars = useCommonVars(),
      wkLabels = _useCommonVars.wkLabels,
      options = _useCommonVars.options;
    var clearFiltersLocalSearchBean = function clearFiltersLocalSearchBean() {
      auctionFiltersSearchBean.value.auctionMinimumOfferFrom = null;
      auctionFiltersSearchBean.value.auctionMinimumOfferTo = null;
      auctionFiltersSearchBean.value.sqMfrom = null;
      auctionFiltersSearchBean.value.sqMto = null;
      auctionFiltersSearchBean.value.roomsTo = null;
      auctionFiltersSearchBean.value.roomsFrom = null;
      /*   auctionFiltersSearchBean.value.auctionCourtTypeID = null;
         auctionFiltersSearchBean.value.auctionProcedureNumber = null;
         auctionFiltersSearchBean.value.auctionReferenceYear = null;*/
      auctionFiltersSearchBean.value.auctionSaleModeID = null;
      auctionFiltersSearchBean.value.auctionDateFrom = null;
      auctionFiltersSearchBean.value.auctionDateTo = null;
      auctionFiltersSearchBean.value.auctionMinimumBid = null;
      auctionFiltersSearchBean.value.auctionPublicationDateFrom = null;
      auctionFiltersSearchBean.value.auctionPublicationDateTo = null;
      optionSellingType.value = 0;
      optionCourtType.value = 0;
      emit("cleared");
      emitChanges();
    };
    var emitChanges = function emitChanges() {
      emit("changed", auctionFiltersSearchBean.value);
    };
    var convertObjToSelectOptions = function convertObjToSelectOptions() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _a, auctionSaleModes, mapToSelectOptions;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getAuctionSaleModeList();
            case 3:
              auctionSaleModes = _context.sent;
              //TODO: spostarla in un composable
              mapToSelectOptions = function mapToSelectOptions(array, idKey, labelKey) {
                return array.map(function (item) {
                  return {
                    id: item[idKey],
                    label: item[labelKey]
                  };
                });
              };
              /* court.value = mapToSelectOptions(courtAuctions, "courtID", "courtName");*/
              sellingType.value = mapToSelectOptions(auctionSaleModes, "auctionSaleModeId", "saleModeName");
              /* if (props.searchBean?.auctionCourtTypeID)
                   optionCourtType.value = court.value.find(item => item.id === props.searchBean?.auctionCourtTypeID);*/
              if ((_a = props.searchBean) === null || _a === void 0 ? void 0 : _a.auctionSaleModeID)
                // eslint-disable-next-line max-len
                optionSellingType.value = sellingType.value.find(function (item) {
                  return item.id === props.searchBean.auctionSaleModeID;
                });
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
    };
    watch(function () {
      return props.searchBean;
    }, function (newValue, oldValue) {
      for (var key in newValue) {
        auctionFiltersSearchBean.value[key] = newValue[key];
      }
    }, {
      deep: true
    });
    watch(function () {
      return props.clearFilters;
    }, function (newValue, oldValue) {
      if (newValue) {
        clearFiltersLocalSearchBean();
      }
    });
    onMounted(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              convertObjToSelectOptions();
              forceCloseMultiTypologyLocal.value = props.forceCloseAllDropDown;
              forceCloseAllDropdown.value = props.forceCloseAllDropDown;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["tw-bg-white tw-rounded tw-p-30px tw-grid tw-gap-x-15px tw-gap-y-25px md:tw-items-baseline", [_ctx.shrinkTo4Columns ? 'tw-grid-cols-4' : 'tw-grid-cols-6', _ctx.customContainerClass]])
      }, [_createCommentVNode(" First row "), _createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(wkLabels).minimumOffer), 1 /* TEXT */), _createVNode(BaseInput, {
        id: "minimum-offer",
        "data-cy": "minimum-offer-input",
        "label-text": "Min",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.auctionMinimumOfferFrom,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function (newValue) {
          auctionFiltersSearchBean.value.auctionMinimumOfferFrom = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"]), _createVNode(BaseInput, {
        id: "max-offer",
        "data-cy": "max-offer-input",
        "label-text": "Max",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.auctionMinimumOfferTo,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function (newValue) {
          auctionFiltersSearchBean.value.auctionMinimumOfferTo = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        "class": "tw-font-semibold tw-col-span-2",
        innerHTML: _unref(wkLabels).surface + " (m<sup>2</sup>)"
      }, null, 8 /* PROPS */, _hoisted_4), _createVNode(BaseInput, {
        id: "min-sqm",
        "data-cy": "min-sqm-input",
        "label-text": "Min",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.sqMfrom,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function (newValue) {
          auctionFiltersSearchBean.value.sqMfrom = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"]), _createVNode(BaseInput, {
        id: "max-sqm",
        "data-cy": "max-sqm-input",
        "label-text": "Max",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.sqMto,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function (newValue) {
          auctionFiltersSearchBean.value.sqMto = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"])]), _createElementVNode("div", {
        "class": _normalizeClass(["tw-col-span-full md:tw-col-span-2 tw-grid tw-gap-x-15px", _ctx.insideModal ? 'md:tw-self-center' : ''])
      }, [_createElementVNode("span", {
        "class": "tw-font-semibold tw-col-span-2",
        innerHTML: _unref(wkLabels).rooms
      }, null, 8 /* PROPS */, _hoisted_5), _createVNode(BaseInput, {
        id: "min-rooms",
        "data-cy": "min-rooms-input",
        "label-text": "Min",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.roomsFrom,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function (newValue) {
          auctionFiltersSearchBean.value.roomsFrom = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"]), _createVNode(BaseInput, {
        id: "max-rooms",
        "data-cy": "max-rooms-input",
        "label-text": "Max",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.roomsTo,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function (newValue) {
          auctionFiltersSearchBean.value.roomsTo = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"])], 2 /* CLASS */), _createCommentVNode(" Second row "), _createCommentVNode("    <base-input\n                id=\"procedure-number\"\n                class=\"tw-col-span-full md:tw-col-span-2 md:tw-self-end\"\n                data-cy=\"procedure-number-input\"\n                :label-text=\"wkLabels.procedureNumber\"\n                pattern=\"\\d*\"\n                inputmode=\"numeric\"\n                :formatter=\"formatter\"\n                label-classes=\"tw-truncate\"\n                :model-value=\"auctionFiltersSearchBean.auctionProcedureNumber\"\n                @update:model-value=\"newValue => {auctionFiltersSearchBean.auctionProcedureNumber = newValue ; emitChanges() }\"\n              />\n              <base-input\n                id=\"reference-year\"\n                class=\"tw-col-span-full md:tw-col-span-2 md:tw-self-end\"\n                data-cy=\"reference-year-input\"\n                :label-text=\"wkLabels.procedureYear\"\n                pattern=\"\\d{4}\"\n                inputmode=\"numeric\"\n                min=\"2020\"\n                max=\"2050\"\n                :formatter=\"formatter\"\n                label-classes=\"tw-truncate\"\n                :model-value=\"auctionFiltersSearchBean.auctionReferenceYear\"\n                @update:model-value=\"newValue => {auctionFiltersSearchBean.auctionReferenceYear = newValue ; emitChanges() } \"\n              />\n\n              <accessible-select\n                namespace=\"court\"\n                class=\"tw-col-span-full md:tw-col-span-2 tw-mt-5px\"\n                data-cy=\"court-select\"\n                :label=\"wkLabels.court\"\n                :options=\"court\"\n                legend-classes=\"tw-float-none tw-w-auto tw-text tw-mb-0 tw-mt-5px\"\n                :model-value=\"optionCourtType\"\n                :manual-close-dropdown=\"forceCloseAllDropdown\"\n                @update:model-value=\"newValue =>{ auctionFiltersSearchBean.auctionCourtTypeID= newValue.id; optionCourtType = newValue ; emitChanges() }\"\n              />"), _createVNode(AccessibleSelect, {
        namespace: "selling-type",
        "class": _normalizeClass(["tw-col-span-full md:tw-col-span-2 tw-mt-[7px] tw-self-end", _ctx.listingTypologyActive ? 'md:!tw-mt-30px' : '']),
        "data-cy": "selling-type-select",
        label: _unref(wkLabels).sellingTypes,
        options: sellingType.value,
        "legend-classes": "tw-float-none tw-w-auto tw-text tw-mb-0",
        "model-value": optionSellingType.value,
        "manual-close-dropdown": forceCloseAllDropdown.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function (newValue) {
          auctionFiltersSearchBean.value.auctionSaleModeID = newValue.id;
          optionSellingType.value = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["class", "label", "options", "model-value", "manual-close-dropdown"]), _createCommentVNode(" Third row "), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(VueDatePicker), {
        uid: "auction-date-from",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).sellingDateFrom,
        format: _unref(formatDateToddMMYYYY),
        "min-date": minDate.value,
        "max-date": auctionFiltersSearchBean.value.auctionDateTo ? auctionFiltersSearchBean.value.auctionDateTo : null,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionDateFrom,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function (newValue) {
          auctionFiltersSearchBean.value.auctionDateFrom = newValue;
          emitChanges();
        }),
        onCleared: _cache[8] || (_cache[8] = function ($event) {
          auctionFiltersSearchBean.value.auctionDateFrom = '';
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "max-date", "model-value"])]), _createCommentVNode(" Fourth row "), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(VueDatePicker), {
        uid: "auction-date-to",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).sellingDateTo,
        format: _unref(formatDateToddMMYYYY),
        "min-date": auctionFiltersSearchBean.value.auctionDateFrom ? auctionFiltersSearchBean.value.auctionDateFrom : minDate.value,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionDateTo,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function (newValue) {
          auctionFiltersSearchBean.value.auctionDateTo = newValue;
          emitChanges();
        }),
        onCleared: _cache[10] || (_cache[10] = function ($event) {
          auctionFiltersSearchBean.value.auctionDateTo = '';
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "model-value"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(VueDatePicker), {
        uid: "publication-date-from",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).publicationDateFrom,
        format: _unref(formatDateToddMMYYYY),
        "min-date": minDate.value,
        "max-date": auctionFiltersSearchBean.value.auctionPublicationDateTo ? auctionFiltersSearchBean.value.auctionPublicationDateTo : null,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionPublicationDateFrom,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function (newValue) {
          auctionFiltersSearchBean.value.auctionPublicationDateFrom = newValue;
          emitChanges();
        }),
        onCleared: _cache[12] || (_cache[12] = function ($event) {
          auctionFiltersSearchBean.value.auctionPublicationDateFrom = null;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "max-date", "model-value"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_unref(VueDatePicker), {
        uid: "publication-date-to",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).publicationDateTo,
        format: _unref(formatDateToddMMYYYY),
        "min-date": auctionFiltersSearchBean.value.auctionPublicationDateFrom ? auctionFiltersSearchBean.value.auctionPublicationDateFrom : minDate.value,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionPublicationDateTo,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = function (newValue) {
          auctionFiltersSearchBean.value.auctionPublicationDateTo = newValue;
          emitChanges();
        }),
        onCleared: _cache[14] || (_cache[14] = function ($event) {
          auctionFiltersSearchBean.value.auctionPublicationDateTo = '';
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "model-value"])]), _createVNode(BaseInput, {
        id: "minimum-bid",
        "class": "tw-col-span-full md:tw-col-span-2",
        "data-cy": "minimum-bid-input",
        "label-text": _unref(wkLabels).minimumBid,
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.auctionMinimumBid,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = function (newValue) {
          auctionFiltersSearchBean.value.auctionMinimumBid = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["label-text", "formatter", "model-value"])], 2 /* CLASS */);
    };
  }
});